import React, {useRef} from "react";
import PropTypes from 'prop-types';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import {Tooltip} from "@material-ui/core";
import VsEditor from '@monaco-editor/react';
import {
    sysbuFnSuggestions
} from "../../../../../Components/ApplicationBuilder/ApplicationDesigner/Designers/ScreenDesigner/utils/sysbuFnSuggestions";

const VsCodeEditor = (props) => {
    const {
        onChange, onKeyDown, onBlur,
        currentValue, mode, fullScreen, autoFocus,
        style = {}, openInPopup, hideOpenInPopup, entitySuggestion
    } = props;
    const editorRef = useRef(null);

    function handleEditorWillMount(monaco) {
        monaco.languages.registerCompletionItemProvider("javascript", {
            triggerCharacters: ["."], // Trigger on '.'
            provideCompletionItems: (model, position) => {
                try {
                    const textBeforeCursor = model.getValueInRange({
                        startLineNumber: position.lineNumber,
                        startColumn: 1,
                        endLineNumber: position.lineNumber,
                        endColumn: position.column
                    });

                    // 🔹 Find last object reference (e.g., "user." or "user.address.")
                    const entityPattern = entitySuggestion?.entityList.join("|"); // 'user|role'
                    const regex = new RegExp(`(${entityPattern})(\\.[a-zA-Z0-9_$]+)*\\.$`);

                    const match = textBeforeCursor.match(regex);

                    const path = match ? match[0].slice(0, -1) : null; // Remove last '.'
                    const matchingPaths = match ?
                        entitySuggestion?.allPaths.filter(p => p.startsWith(path + ".")) : [];

                    const entityRules = matchingPaths.map(fullPath => {
                        const key = fullPath.replace(path + ".", ""); // Extract next-level key
                        return {
                            label: key,
                            kind: monaco.languages.CompletionItemKind.Variable,
                            insertText: key,
                            detail: `Property of ${path}`
                        };
                    });
                    const sysbuRules = sysbuFnSuggestions(monaco)
                    return {
                        suggestions: [
                            ...entityRules,
                            ...sysbuRules
                        ]
                    };
                } catch (e) {
                    console.log(e)
                    return {}
                }
            }
        });
    }

    function handleEditorDidMount(editor, monaco) {
        try {
            editorRef.current = editor;
            editor.focus();

            editor.onDidBlurEditorWidget(()=>{
                onBlur(editor.getValue())
            });
        } catch (e) {
            console.log('e', e)
        }
    }

    return (
        <div
            style={{
                padding: 1,
                width: fullScreen ? '100%' : style.width ? style.width : 510,
                height: fullScreen ? '100%' : style.height || 'auto',
                border: hideOpenInPopup ? 'none' : '1px solid rgba(0, 0, 0, 0.26)',
                margin: hideOpenInPopup ? 0 : '0 3px',
                borderRadius: '4px'
            }}
            onKeyDown={(event => onKeyDown(event))}
        >
            <div style={{background: '#f7f7f7', display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                {!hideOpenInPopup && (
                    <>
                        <Tooltip title={'Open In Popup'}>
                            <IconButton style={{padding: 0}} onClick={openInPopup}>
                                <OpenInNewIcon style={{fontSize: "1rem"}}/>
                            </IconButton>
                        </Tooltip>
                        <Divider/>
                    </>
                )}
            </div>
            <VsEditor
                defaultLanguage={"javascript"}
                width={fullScreen ? '100%' : style.width ? style.width - 5 : '500px'}
                height={fullScreen ? '100%' : style.height ? style.height : '150px'}
                value={`${currentValue}`}
                onChange={onChange}
                theme={'vs-dark'}
                onMount={handleEditorDidMount}
                beforeMount={handleEditorWillMount}
            />
        </div>
    )
};
export default VsCodeEditor

VsCodeEditor.propTypes = {
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    onBlur: PropTypes.func,
    currentValue: PropTypes.string,
    mode: PropTypes.string,
    style: PropTypes.object,
    fullScreen: PropTypes.bool,
    openInPopup: PropTypes.bool,
    hideOpenInPopup: PropTypes.bool,
    autoFocus: PropTypes.bool
};

VsCodeEditor.defaultProps = {
    onBlur: () => {
    }
};